import {
  ChakraGrid as Grid,
  ChakraFlex as Flex,
  ChakraDivider as Divider,
  ChakraAspectRatio,
  ChakraBox as Box,
} from "@airhelp/react-ui-components";
import { Image } from "components";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import { RichtextAdapter } from "modules/storyblok/adapters";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import type { ContentWithImageProps } from "./ContentWithImage.d";
import { richTextStyles } from "./ContentWithImage.styles";

export const ContentWithImage = ({
  srcMobile,
  srcDesktop,
  alt,
  reverseColumns = false,
  components,
  bgMobile,
  isIllustration = false,
  topDivider = false,
  ptMobile = "12",
  ptTablet = "12",
  ptDesktop = "12",
  pbMobile = "12",
  pbTablet = "12",
  pbDesktop = "12",
}: ContentWithImageProps) => {
  const columnOrder = reverseColumns ? { base: 0, md: -1 } : 0;

  const bg = { base: bgMobile ? "greyscale.200" : "transparent", md: "transparent" };
  const imageMaxWidth = isIllustration ? { base: 32, md: "512px" } : "full";

  return (
    <>
      {topDivider && (
        <Box w="full" px={4} mx="auto">
          <Divider
            display={{ base: "none", md: "block" }}
            my={12}
            mx="auto"
            width="full"
            maxWidth={MAX_GRID_WIDTH}
            opacity={1}
            borderColor="greyscale.500"
          />
        </Box>
      )}
      <Box bg={bg} width="full">
        <Grid
          maxWidth={MAX_GRID_WIDTH}
          mx="auto"
          templateColumns={{ base: "1fr", md: "1fr 1fr" }}
          alignItems="center"
          pt={{ base: ptMobile, md: ptTablet, lg: ptDesktop }}
          pb={{ base: pbMobile, md: pbTablet, lg: pbDesktop }}
          px={4}
          gap={{ base: 1, md: 4, xl: 8 }}
        >
          <ChakraAspectRatio ratio={1} maxWidth={imageMaxWidth}>
            <Image srcDesktop={srcDesktop} srcMobile={srcMobile} alt={alt} />
          </ChakraAspectRatio>

          <Flex order={columnOrder} direction="column" alignItems="flex-start">
            {components.map((component) =>
              component.component === "content" ? (
                <RichtextAdapter key={component._uid} content={component.content} customStyles={richTextStyles} />
              ) : (
                <DynamicComponent key={component._uid} blok={component} />
              )
            )}
          </Flex>
        </Grid>
      </Box>
    </>
  );
};
